import { isCryptoCurrency } from "@common/lib/currency";
import classNames from "classnames";
import React from "react";

export type FlagProps = {
  cultureCode?: string;
  iso2?: string;
  size?: number;
  style?: React.CSSProperties;
  isRound?: boolean;
};

const Flag = (props: FlagProps) => {
  const iso2 = React.useMemo(() => {
    if (props.iso2) return props.iso2.toLowerCase();
    return props.cultureCode!.toLowerCase().split("-").pop();
  }, [props.iso2, props.cultureCode]);

  return (
    <img
      className={classNames("flag", { round: props.isRound })}
      src={`https://d1qgwakyzw6n5u.cloudfront.net/common/images/flags/${iso2}.svg`}
      style={{ "--flag-size": `${props.size}px`, height: props.size, width: props.size } as any}
    />
  );
};

export default Flag;

export type FlagWithLabelProps = FlagProps & {
  ref?: React.RefObject<HTMLElement> | null;
  onClick?: () => void;
  label: any;
};
export const FlagWithLabel = ({ label, onClick, ref, ...props }: FlagWithLabelProps) => (
  <span
    ref={ref}
    className={classNames({ pointer: onClick })}
    onClick={onClick}
    style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
  >
    <Flag {...props} />
    <span style={{ paddingLeft: 8 }}>{label}</span>
  </span>
);

export type CurrencyFlagProps = {
  currencyCode: string;
  size: number;
  isRound?: boolean;
};

export const CurrencyFlag = (props: CurrencyFlagProps) => {
  const iso2 = React.useMemo(() => props.currencyCode!.substring(0, 2).toLowerCase(), [props.currencyCode]);

  const path = isCryptoCurrency(props.currencyCode)
    ? `/crypto/${props.currencyCode.toLowerCase()}.svg`
    : `/flags/${iso2}.svg`;
  return (
    <div
      className={classNames("currency_flag", { round: props.isRound })}
      style={{ "--flag-size": `${props.size}px` } as any}
    >
      <img className="flag" src={`https://d1qgwakyzw6n5u.cloudfront.net/common/images${path}`} />
    </div>
  );
};

export type CurrencyFlagWithLabelProps = CurrencyFlagProps & {
  label: string;
};
export const CurrencyFlagWithLabel = ({ label, ...props }: CurrencyFlagWithLabelProps) => (
  <span style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
    <CurrencyFlag {...props} />
    <span className="currency_label" style={{ paddingLeft: 8 }}>
      {label}
    </span>
  </span>
);
